export default "__VITE_ASSET__BExxtsDV__"